/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var Marionette = require('backbone.marionette');
var Ladda = require('ladda');
var Radio = require('backbone.radio');
var Syphon = require('backbone.syphon');

var modelGet = require('common/util/modelGet');
var UIUtil = require('psa-core/util/ui');

var BreadcrumbView = require('common/views/BreadcrumbView');
var ExamHeaderBarView = require('../../common/views/ExamHeaderBarView');
var GridView = require('psa-marionette/views/GridView');
var MultiButtonCell = require('common/backgrid/MultiButtonCell');
var DollarCell = require('common/backgrid/DollarCell');
var SubmitUpdateExamResults = require('../services/SubmitUpdateExamResults');

var ExamViolationModalView = require('../../tasks/views/ExamViolationModalView');
var tmplNonDepInternalExamUpdateBillingDetailsView = require('../templates/NonDepInternalExamUpdateExamResults.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplNonDepInternalExamUpdateBillingDetailsView,

  className: 'non-dep-internal-exam-update-billing-details-view container-fluid',

  ui: {
    addViolationBtn: '.add-violation',
    violationsGridContainer: '.violations-grid-container',
    headerBar: '.header-bar',
    breadcrumb: '.breadcrumb-container',
    examResultsForm: '.update-exam-results-form',
    refundAmountOverride: 'input[name="refundAmountOverride"]',
    billingComments: 'textarea[name="billingComments"]',
    submit: '.submit'
  },

  regions: {
    headerBar: '@ui.headerBar',
    breadcrumb: '@ui.breadcrumb',
    violationsGridContainer: '@ui.violationsGridContainer'
  },

  events: {
    'click @ui.addViolationBtn': 'onClickAddViolation',
    'click @ui.submit': 'onClickSubmit'
  },

  onBeforeShow: function() {
    var exam = this.model.get('exam') || {};
    var examId = exam.examId;
    this.showChildView(
      'headerBar',
      new ExamHeaderBarView({
        model: new Backbone.Model(_.extend(exam, { title: 'Exam' }))
      })
    );

    var licenseNumber = this.model.get('exam').licenseNumber;
    var licenseId = this.model.get('exam').licenseId;
    var entityId = this.model.get('exam').entityId;
    var entityName = this.model.get('exam').entityName;

    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: [
          {
            link: '#nondep/dashboard',
            text: 'Home'
          },
          {
            text: entityName,
            link: '#nondep/entity/' + entityId + '/dashboard'
          },
          {
            text: 'License #' + licenseNumber,
            link: '#nondep/entity/' + entityId + '/license/' + licenseId
          },
          {
            text: 'Exam #' + examId,
            link: '#nondep/dashboard/exam/' + examId
          },
          {
            text: 'Edit Exam Results'
          }
        ]
      })
    );

    this.violationsGridContainer = new GridView({
      columns: [
        {
          name: 'violationName',
          label: 'Violation',
          cell: 'string',
          headerCell: 'custom',
          width: 35,
          editable: false
        },
        {
          name: 'violationCorrectiveActionName',
          label: 'Status',
          cell: 'string',
          headerCell: 'custom',
          width: 33,
          editable: false
        },
        {
          name: 'refundAmount',
          label: 'Refund Amount',
          cell: DollarCell,
          headerCell: 'custom',
          width: 16,
          editable: false
        },
        {
          name: 'editDeleteMultiButtonCell',
          label: '',
          width: 16,
          cell: MultiButtonCell.extend({
            buttons: [
              {
                name: 'Edit',
                labelClass: '',
                buttonClass: 'btn-primary btn-sm',
                onClick: this.onClickEditViolation.bind(this)
              },
              {
                name: 'Remove',
                labelClass: '',
                buttonClass: 'btn-danger btn-sm',
                onClick: this.onClickRemoveViolation.bind(this)
              }
            ]
          }),
          editable: false,
          sortable: false
        }
      ],
      collection: new Backbone.Collection(exam.examViolations),
      emptyText: 'No Violations Added'
    });

    this.showChildView('violationsGridContainer', this.violationsGridContainer);

    this.ui.refundAmountOverride.val(exam.refundAmountOverride);

    if (exam.billingComments) {
      this.ui.billingComments.val('\n\n' + exam.billingComments);
    }
  },

  updateTotalRefund: function() {
    var totalRefund = 0;
    this.violationsGridContainer.collection.each(function(log) {
      var refundAmount = parseFloat(log.get('refundAmount')) || 0;
      totalRefund += refundAmount;
    });
    this.ui.refundAmountOverride.val(totalRefund);
  },

  onClickAddViolation: function(e) {
    e.preventDefault();
    this.openViolationModal();
    //this.updateTotalRefund();
  },

  onClickEditViolation: function(e, model) {
    e.preventDefault();
    this.openViolationModal(model);
  },

  onClickRemoveViolation: function(e, model) {
    e.preventDefault();
    this.violationsGridContainer.collection.remove(model);
    this.updateTotalRefund();
  },

  getFormData: function() {
    var supportingDocuments = this.fileUploadTable.getFormData();
    var examDocumentId = this.examDocument.getFirstFileId();
    var examTransmittalDocId = this.examSummaryContainer.getFirstFileId();
    var violations = this.violationsGridContainer.collection.toJSON();

    return {
      supportingDocuments: supportingDocuments,
      violations: violations,
      examDocumentId: examDocumentId,
      examTransmittalDocId: examTransmittalDocId
    };
  },

  openViolationModal: function(model) {
    var self = this;
    UIUtil.showModal({
      title: 'Exam Violation',
      dialogClasses: 'modal-dialog-exam-violation-modal-view',
      view: new ExamViolationModalView({
        examViolationCodes: modelGet(self.model, 'exam.examViolationCodes'),
        examViolationCorrectiveActions: modelGet(self.model, 'exam.examViolationCorrectiveActions'),
        model: model
      })
    }).done(function(violation) {
      if (model) {
        // Edit
        model.set(violation);
      } else {
        // Add
        self.violationsGridContainer.collection.add(violation);
      }
      self.updateTotalRefund();
    });
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    var self = this;
    this.validate().done(
      function() {
        var l = Ladda.create(this.ui.submit[0]);
        l.start();

        var formData = Syphon.serialize(this);
        var violations = this.violationsGridContainer.collection.toJSON();
        var examId = modelGet(this.model, 'exam.examId');

        _.extend(formData, {
          examId: examId,
          violations: violations
        });

        formData.refundAmountOverride = self.ui.refundAmountOverride.val();

        SubmitUpdateExamResults(formData)
          .done(function() {
            Radio.channel('navigate').trigger('show:int:nd:dashboard:exams:dashboard', examId);
          })
          .fail(function() {
            l.stop();
          });
      }.bind(this)
    );
  },

  validate: function() {
    return this.ui.examResultsForm.parsley().whenValidate();
  }
});
